import { ReactNode } from 'react';

interface CFSPrintCardProps {
  title?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

const CFSPrintCard = ({ title, children, footer }: CFSPrintCardProps) => {
  return (
    <>
      {title && (
        <div className="font-medium my-2 border border-[#E7EAEC] dark:border-gray-600 flex items-center justify-center text-gray-900 dark:text-gray-100 bg-[#E7EAEC] dark:bg-gray-700 py-2.5 px-4 w-full">
          {title}
        </div>
      )}
      <div className="w-full border border-gray-300 dark:border-gray-600 rounded mb-2 bg-white dark:bg-[#17252D] text-gray-900 dark:text-gray-100">
        <div className="px-3 py-2">{children}</div>
        {footer && (
          <div className="px-3 py-2 border-t border-gray-300 dark:border-gray-600">
            {footer}
          </div>
        )}
      </div>
    </>
  );
};

export default CFSPrintCard;
